<div class="button-outer">
  <div class="button-wrapper">
    <ion-button data-cy="fileCopyDecreaseBtn" class="counter-icon" (click)="decrease()">
      <ion-icon slot="icon-only" name="remove"></ion-icon>
    </ion-button>
  </div>
</div>
<span class="counter-value">{{ counterValue }}</span>
<div class="button-outer">
  <div class="button-wrapper">
    <ion-button data-cy="fileCopyIncreaseBtn" class="counter-icon" (click)="increase()">
      <ion-icon slot="icon-only" name="add"></ion-icon>
    </ion-button>
  </div>
</div>